import React from 'react';
import BzitCountUsageImage from '../../bzit/BzitCountUsageImage';
import BzitLabel from '../../bzit/BzitLabel';
import { Column } from '../../components/Grid';
import {
  BustypeRow,
  Description,
  DescriptionColumn,
  DescriptionName,
  DescriptionUsage
} from '../../components/Stage';
import { Maybe } from '../../types';

interface BustypeDoubleDeckerProps {
  bodies: { [key: string]: Maybe<number> };
  clickShowSearchResult: () => void;
}

export const DoubleDeckerKey = 'A01';

const BustypeDoubleDecker = ({
  clickShowSearchResult,
  bodies
}: BustypeDoubleDeckerProps) => (
  <Column medium={6} small={12}>
    <BustypeRow noGap bg="white" onClick={clickShowSearchResult}>
      <Column small={6}>
        <BzitCountUsageImage type="DOUBLE_DECKER" />
      </Column>
      <DescriptionColumn small={6}>
        <Description>
          <DescriptionUsage>{bodies[DoubleDeckerKey] || 0}</DescriptionUsage>
          <DescriptionName>
            <BzitLabel label={DoubleDeckerKey} />
          </DescriptionName>
        </Description>
      </DescriptionColumn>
    </BustypeRow>
  </Column>
);

export default BustypeDoubleDecker;
